/**
 * Promotion Service
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface OfferStatusUpdateRequest { 
    status: OfferStatusUpdateRequest.StatusEnum;
}
export namespace OfferStatusUpdateRequest {
    export const StatusEnum = {
        Draft: 'DRAFT',
        Active: 'ACTIVE',
        Inactive: 'INACTIVE'
    } as const;
    export type StatusEnum = typeof StatusEnum[keyof typeof StatusEnum];
}


